import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import { throttle }from 'lodash'
import Empty from "./empty";

type Props = {
    onChange:(page:number) => void,
    ref:React.Ref<any>,
    length:number,
    noEmpty?:boolean
}

const addPage = throttle((page,props) => {
    page.current+=1
    props.onChange(page.current)
},1000,{ trailing:false })


const Pagination:React.FC<Props> = React.forwardRef((props,ref) => {
    const [hasMore,setMore] = useState<boolean>(true);
    const target = useRef(null);
    const page = useRef(1);
    const timer = useRef<number | null>(null)


    useImperativeHandle(ref,() => ({
        setStatus:(status:boolean) => {
            // console.log(status)
            setMore(status)
        },
        reset:() => {
            page.current = 1
        }
    }))

    const checkStatus = () => {
        if(timer.current){
            clearTimeout(timer.current)
        }

        timer.current = setTimeout(() => {
            addPage(page,props)
        },3000)
    }


    useEffect(() =>{
        if(props.length && props.length > 0 ){

            const io = new IntersectionObserver(entries => {
                if(hasMore){
                    addPage(page,props)
                    checkStatus()
                }
            },{
                threshold:1.0
            })

            // @ts-ignore
            io.observe(target.current)

            return () => {
                // @ts-ignore
                io.unobserve(target.current)
                io.disconnect()
                if(timer.current){
                    clearTimeout(timer.current)
                }
            }
        }
    },[hasMore,props.length])


    return <div className="pagination" ref={target}>
        {
            (!hasMore && props.length === 0) &&  (props.noEmpty ? <p>没有更多了</p> : <Empty>暂无数据</Empty>)
        }
        {
            props.length > 0 && <p>
                {
                    hasMore ? '加载中...' : '没有更多了'
                }
            </p>
        }
    </div>
})

export default Pagination
